<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-select size="mini" v-model="formDatas.asId" filterable clearable @change="partserch"
                        placeholder="请选择所属商户" style="width: 130px;">
                        <el-option v-for="(item, index) in getAjefShopList_data" :key="index" :label="item.asName"
                            :value="item.asId"></el-option>
                    </el-select>
                    <el-select size="mini" v-model="formDatas.ausId" filterable clearable @change="partserch"
                        placeholder="请选择所属商户用户" style="width: 130px;">
                        <el-option v-for="(item, index) in getAjefUserShopList_data" :key="index" :label="item.ausName"
                            :value="item.ausId"></el-option>
                    </el-select>
                    <el-input v-model="formDatas.auwName" style="width: 120px;" size="mini" placeholder="名称"
                        clearable></el-input>
                    <el-input v-model="formDatas.auwPhone" style="width: 120px;" size="mini" placeholder="手机号"
                        clearable></el-input>
                    <el-select size="mini" v-model="formDatas.auwParentType" clearable @change="partserch"
                        placeholder="请选择上级类型" style="width: 130px">
                        <el-option label="无" :value="1"></el-option>
                        <el-option label="店铺" :value="2"></el-option>
                        <el-option label="员工" :value="3"></el-option>
                        <el-option label="用户" :value="4"></el-option>
                    </el-select>
                    <el-select size="mini" v-model="formDatas.ausStatus" clearable @change="partserch"
                        placeholder="请选择账号状态" style="width: 130px">
                        <el-option label="正常" :value="1"></el-option>
                        <el-option label="已禁用" :value="2"></el-option>
                        <el-option label="已删除" :value="3"></el-option>
                    </el-select>
                    <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                    <!-- <el-button type="primary" size="mini" style="margin-right: 10px;"
                        @click="bulkImport = true">批量导入</el-button> -->
                    <!-- <el-button type="warning" size="mini" style="margin-right: 10px;" @click="Out()">导出</el-button>
                    <el-button type="danger" size="mini" style="margin-left: 10px" @click="BulkDelete">批量撤销</el-button> -->
                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                    <!-- <el-button type="success" size="mini" style="margin-right: 20px" @click="BoxOpen">新增银行</el-button> -->

                    <!-- <el-button type="warning" size="mini" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption"
                        row-key-field-name="auwId" :cellSelectionOption="cellSelectionOption" style="width: 100%"
                        :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 新增 -->
            <el-drawer :wrapperClosable="false" :title="edit == true ? '编辑银行' : '新增银行'" :before-close="handleClose"
                :visible.sync="dialog" direction="rtl" custom-class="demo-drawer" ref="drawer">
                <div class="demo-drawer__content" style="height: 90%;">
                    <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
                        <div
                            style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                            <el-form-item label="银行名称" prop="asboBankName">
                                <el-input v-model="form.asboBankName" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <div class="demo-drawer__footer" style="margin-top: 10px;">
                    <el-button @click="handleClose()" style="margin-left: 20%;">取 消</el-button>
                    <el-button type="primary" @click="SureBtn" style="margin-left: 150px;">
                        确 定</el-button>
                </div>
            </el-drawer>
            <el-dialog title="每月结算记录和账单" :visible.sync="isMerchantUserShow" width="70%" top="8vh"
                :close-on-click-modal="false">
                <div style="width: 100%;text-align: center;font-size: 20px;"
                    v-if="merchantDetail && merchantDetail.length > 0">
                    {{ merchantDetail[merchantDetail.length -
                        1].orderYearMonth + '' }} 结算记录</div>
                <div style="width: 100%;height: 130px;display: flex;align-items: center;justify-content: space-between;margin: 20px 0;"
                  v-if="merchantDetail && merchantDetail.length > 0">
                    <div style="width: 31%;height: 120px;margin: 10px auto;overflow: hidden;display: flex;
                    flex-direction: column;align-items: center;justify-content: center;padding: 15px;border-radius: 10px;
                    background-color:#F2F6FC; box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);">
                        <div style="font-size: 15px;color:  #86909c;margin-bottom: 15px">预计收益金额</div>
                        <div style="font-size: 20px;color:  #86909c;margin-bottom: 10px;font-weight: 700;">
                            ¥{{
                                merchantDetail[merchantDetail.length
                                    - 1].orderMoneyYuan * 1 || '0' }}</div>
                    </div>
                    <div style="width: 31%;height: 120px;margin: 10px auto;overflow: hidden;display: flex;
                    flex-direction: column;align-items: center;justify-content: center;padding: 15px;border-radius: 10px;
                    background-color:#F2F6FC; box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);">
                        <div style="font-size: 15px;color:  #86909c;margin-bottom: 15px">可结算金额</div>
                        <div style="font-size: 20px;color:  #86909c;margin-bottom: 10px;font-weight: 700;">
                            ¥{{
                                merchantDetail[merchantDetail.length
                                    - 1].orderMoneySettlementYuan * 1 || '0' }}</div>
                    </div>
                    <div style="width: 31%;height: 120px;margin: 10px auto;overflow: hidden;display: flex;
                    flex-direction: column;align-items: center;justify-content: center;padding: 15px;border-radius: 10px;
                    background-color:#F2F6FC; box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);">
                        <div style="font-size: 15px;color:  #86909c;margin-bottom: 15px">退款金额</div>
                        <div style="font-size: 20px;color:  #86909c;margin-bottom: 10px;font-weight: 700;">
                            ¥{{
                                merchantDetail[merchantDetail.length
                                    - 1].orderMoneyRefundYuan * 1 || '0' }}</div>
                    </div>
                </div>
                <el-card
                    v-if="merchantDetail && merchantDetail.length > 0"
                    style="width: 100%;margin-top: 20px;">
                    <div slot="header" class="clearfix">
                        <span>每月结算记录</span>
                    </div>
                    <div>
                        <ve-table ref="vetable3" :columns="columnsMonyeyList"
                            :table-data="merchantDetail" :max-height="400" :border-x="true"
                            :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption"
                            row-key-field-name="asId" style="width: 100%" />
                        <div v-show="merchantDetail && merchantDetail.length == 0"
                            class="empty-data">暂无数据
                        </div>
                    </div>
                </el-card>
                 <el-card
                    v-if="merchantSettlementList && merchantSettlementList.length > 0"
                    style="width: 100%;margin-top: 20px;">
                    <div slot="header" class="clearfix">
                        <span>我的账单</span>
                    </div>
                    <div>
                        <ve-table ref="vetable4" :columns="columnsBillList"
                            :table-data="merchantSettlementList" :max-height="400" :border-x="true"
                            :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption"
                            row-key-field-name="asId" style="width: 100%" />
                        <div v-show="merchantSettlementList && merchantSettlementList.length == 0"
                            class="empty-data">暂无数据
                        </div>
                    </div>
                </el-card>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import qs from 'qs';
import axios from 'axios';
import config from '../../api/env.js';
import { getAjefOrderBillList,getAjefShopList, deleteAjefShopBankOptinons, getAjefUserShopList, getAjefUserWxList, addAjefShopBankOptinons, updateAjefShopBankOptinons, getAjefOrderSettlementWxList } from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            merchantDetail:[],
            merchantSettlementList:[],
            isMerchantUserShow:false,
            columnsBillList: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    fixed: 'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "orderNo",
                    key: "orderNo",
                    title: "订单号",
                    align: "center",
                    fixed: 'left',
                    width: 200,
                },
                {
                    field: "orderYearMonth",
                    key: "orderYearMonth",
                    title: "账单所属年月",
                    align: "center",
                    // fixed: 'left',
                    width: 160,
                },
                {
                    field: "aobTitle",
                    key: "aobTitle",
                    title: "商品描述",
                    align: "center",
                    width: 260,
                },
                {
                    field: "orderNoSub",
                    key: "orderNoSub",
                    title: "子订单号",
                    align: "center",
                    width: 160,
                },
                {
                    field: "aobUserPayYuan",
                    key: "aobUserPayYuan",
                    title: "支付金额",
                    align: "center",
                    width: 160,
                },
                {
                    field: "aobUserSettlementYuan",
                    key: "aobUserSettlementYuan",
                    title: "可用于结算金额",
                    align: "center",
                    width: 160,
                },
                {
                    field: "aobUserFreightYuan",
                    key: "aobUserFreightYuan",
                    title: "支付运费",
                    align: "center",
                    width: 160,
                },
                {
                    field: "aobUserRefundYuan",
                    key: "aobUserRefundYuan",
                    title: "退款金额",
                    align: "center",
                    width: 160,
                },

                { field: "orderTimePay", key: "orderTimePay", title: "交易时间", width: 160, align: "center" },
                { field: "orderTimeComplete", key: "orderTimeComplete", title: "完成时间", width: 160, align: "center" },
                { field: "orderTimeRefund", key: "orderTimeRefund", title: "退款时间", width: 160, align: "center" },
                {
                    field: "aobType",
                    key: "aobType",
                    title: "交易类型",
                     fixed: "right",
                    align: "center",
                    width: 110,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return row.aobType == 1 ? <el-tag >正常交易</el-tag> : <el-tag type="danger">退款</el-tag>;
                    },
                },
                {
                    field: "aobHandlerStatusUser",
                    key: "aobHandlerStatusUser",
                    title: "用户结算状态",
                    align: "center",
                     fixed: "right",
                    width: 110,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return row.aobHandlerStatusUser == 1 ? <el-tag >未结算</el-tag> : <el-tag type="danger">已结算</el-tag>;
                    },
                },
                {
                    field: "aobHandlerStatusShop",
                    key: "aobHandlerStatusShop",
                    title: "商家结算状态",
                    fixed: "right",
                    align: "center",
                    width: 110,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return row.aobHandlerStatusShop == 1 ? <el-tag >未结算</el-tag> : <el-tag type="danger">已结算</el-tag>;
                    },
                },
                {
                    field: "aobStatus",
                    key: "aobStatus",
                    title: "状态",
                    align: "center",
                    fixed: "right",
                    width: 110,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return row.aobStatus == 1 ? <el-tag >正常</el-tag> : <el-tag type="danger">退款</el-tag>;
                    },
                },
            ],
            columnsMonyeyList: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "orderYearMonth",
                    key: "orderYearMonth",
                    title: "结算年月",
                    fixed: 'left',
                    align: "center",
                    edit: false,
                },
                {
                    field: "orderMoneyYuan",
                    key: "orderMoneyYuan",
                    title: "预计收益金额(元)",
                    fixed: 'left',
                    align: "center",
                    edit: false,
                },
                {
                    field: "orderMoneySettlementYuan",
                    key: "orderMoneySettlementYuan",
                    title: "可结算金额(元)",
                    fixed: 'left',
                    align: "center",
                    edit: false,
                },
                {
                    field: "orderMoneyRefundYuan",
                    key: "orderMoneyRefundYuan",
                    title: "退款金额(元)",
                    fixed: 'left',
                    align: "center",
                    edit: false,
                },

            ],
            merchantSettlementList: [],
            getAjefUserShopList_data: [],
            getAjefShopList_data: [],
            theRow: {},
            form2: {},
            diaAddReturn: false,
            diaDetail: false,
            tableDataDetail: [],
            dialogStatusValue: '',
            dialogStatus: false,
            key: 'auwId',
            dialog: false,
            edit: false,
            form: {
            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,

            columns: [
                // {
                //     field: "",
                //     key: "checkbox",
                //     // type=checkbox
                //     type: "checkbox",
                //     fixed: 'left',
                //     title: "",
                //     width: 50,
                //     align: "center",
                // },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "asName",
                    key: "asName",
                    title: "所属商户名称",
                    align: "center",
                    fixed: 'left',
                    width: 120,
                },
                {
                    field: "ausName",
                    key: "ausName",
                    title: "所属商户用户名",
                    align: "center",
                    fixed: 'left',
                    width: 120,
                },
                {
                    field: "auwUnionid",
                    key: "auwUnionid",
                    title: "用户unionid",
                    align: "center",
                    width: 120,
                },
                {
                    field: "auwOpenid",
                    key: "auwOpenid",
                    title: "用户openid",
                    align: "center",
                    width: 120,
                },
                {
                    field: "auwName",
                    key: "auwName",
                    title: "用户名",
                    align: "center",
                    width: 120,
                },
                {
                    field: "auwPhone",
                    key: "auwPhone",
                    title: "手机号",
                    align: "center",
                    width: 120,
                },
                {
                    field: "auwEmail",
                    key: "auwEmail",
                    title: "邮箱",
                    align: "center",
                    width: 120,
                },

                {
                    field: "auwHeader",
                    key: "auwHeader",
                    title: "头像",
                    align: "center",
                    width: 120,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span style="display:flex;align-items: center;">
                                <div style="width:100%;">
                                    {
                                        row.auwHeader ? row.auwHeader.split(',').map((item => {
                                            const str = <el-image ref="scrImg" id="scrimg" src={item} alt="" fit="scale-down" style="width: 50px;height: 50px;display: inline-block;"
                                                previewSrcList={[item]}></el-image>
                                            return str
                                        })) : ''
                                    }

                                </div>
                            </span>
                        );
                    },
                },
                {
                    field: "auwSex",
                    key: "auwSex",
                    title: "性别",
                    align: "center",
                    width: 120,
                },
                {
                    field: "auwBirth",
                    key: "auwBirth",
                    title: "生日",
                    align: "center",
                    width: 120,
                },
                {
                    field: "auwParentType",
                    key: "auwParentType",
                    title: "上级类型",
                    align: "center",
                    width: 120,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.ausType == 1 ? <el-tag size="mini" type="danger">无</el-tag> :
                                        row.ausType == 2 ? <el-tag size="mini" type="success">店铺</el-tag> :
                                            row.ausType == 3 ? <el-tag size="mini" type="success">员工</el-tag> :
                                                <el-tag size="mini" type="success">用户</el-tag>
                                }
                            </span>
                        );
                    },
                },
                {
                    field: "ausStatus",
                    key: "ausStatus",
                    title: "状态",
                    align: "center",
                    width: 120,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.ausStatus == 1 ? <el-tag size="mini" type="success">正常</el-tag> :
                                        row.acrStatus == 2 ? <el-tag size="mini" type="danger">已禁用</el-tag> : <el-tag type="danger" size="mini">已删除</el-tag>
                                }
                            </span>
                        );
                    },
                },
                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 100,
                    align: "center",
                    fixed: "right",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <el-button
                                    size="mini"
                                    type="text"
                                    style="color: green"
                                    on-click={() => this.handleDetail(row)}
                                >
                                    账单和结算记录
                                </el-button>
                            </span>
                        );
                    },
                },
            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                dmDelete: 1,
                currentPage: 1,
                pageSize: 10,
            },
            bulkImport: false,
            bulkData: [],
            bulkDataCopy: [],
            sitId: '',
            importData: {},

        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        getAjefShopList({ pageSize: 0 }).then(res => {
            this.getAjefShopList_data = res.data
        })
        getAjefUserShopList().then((res) => {
            this.getAjefUserShopList_data = res.data
        })
        this.getList();
    },
    mounted() { },
    methods: {
        handleDetail(row) {
            this.theRowId = row.auwId;
            getAjefOrderBillList({ auwId: row.auwId }).then(res => {
                this.merchantSettlementList = res.data;
               
            })
            getAjefOrderSettlementWxList({ auwId: row.auwId }).then(res => {
                this.merchantDetail = res.data;
                 this.isMerchantUserShow = true;
            })
        },
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        Out() {
            var s = qs.stringify(this.formDatas);
            this.openLoading()
            var that = this
            axios({
                method: 'post',
                url: config.baseURL + '/ajef-certificate-record/exportAjefCertificateRecord',
                data: s,
                // withCredentials: true,
                timeout: 1200000,
                responseType: 'arraybuffer',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    'user': window.localStorage.getItem('Qy_token')
                }
            }).then(function (res) {
                if (res.data) {
                    that.loadings.close()
                    let a = document.createElement('a');
                    //ArrayBuffer 转为 Blob
                    let blob = new Blob([res.data], {
                        type: "application/vnd.ms-excel"
                    });
                    let objectUrl = URL.createObjectURL(blob);
                    a.setAttribute("href", objectUrl);
                    a.setAttribute("download", '银行兑换.xlsx');
                    a.click();
                    that.$message({
                        message: "成功",
                        type: "success"
                    });

                }
            })
        },
        bulkImportClick() {
            if (this.sitId == '') {
                this.$message({
                    showClose: true,
                    message: "请导入资料",
                    type: 'danger'
                });
            } else {
                uploadImportAjAssetsKey({
                    sitId: this.sitId
                }).then(res => {
                    this.getList()
                    this.bulkImport = false;
                    this.bulkData = [];
                    this.bulkDataCopy = [];
                    this.sitId = '';
                    this.$refs['bulk'].clearFiles()
                    this.$message({
                        type: 'success',
                        message: '导入成功!'
                    });
                })
            }

        },
        async updatabulk(file, fileList) {
            console.log(file, fileList);
            let Data = new FormData();
            Data.append('file', file.raw)
            this.openLoading()
            uploadAjAssetsFireEquipment(Data).then(res => {
                console.log("上传成功")
                this.loadings.close()
                this.bulkData = res.data.data.resultList;
                this.bulkDataCopy = res.data.data.resultList;
                this.importData = res.data.data.importData;
                this.sitId = res.data.data.sysImportTem.sitId;

            })
        },
        bulkImportClose(done) {
            this.$confirm('确认关闭？')
                .then(_ => {
                    done();
                    this.bulkData = [];
                    this.bulkDataCopy = [];
                    this.$nextTick(() => {
                        this.getList()
                    })
                    this.$refs.bulk.clearFiles();
                })
                .catch(_ => { });
        },
        handleStatus(row) {
            this.theRow = row;
            this.dialogStatusValue = row.aakStatus;
            this.dialogStatus = true;
        },
        sureStatus() {
            updateAjAssetsFireEquipmentStatus({ auwId: this.theRow.auwId, aakStatus: this.dialogStatusValue }).then(res => {
                if (res.data) {
                    this.$message({
                        type: "success",
                        message: "修改成功!",
                    });
                    this.getList();
                    this.dialogStatusValue = ''
                }
            })
            this.dialogStatus = false;
        },
        closeStatus() {
            this.dialogStatus = false;
            this.dialogStatusValue = ''
        },
        // 批量删除
        BulkDelete() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0) {
                this.$confirm("是否确定吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        cancelAjefCertificateRecordMulti({ auwIds: this.selectedRowKeysCollection.toString() }).then(res => {
                            this.$message({
                                type: "success",
                                message: "成功!",
                            });
                            this.checkboxOption.selectedRowKeys = [];
                            this.selectedRowKeysCollection = [];
                            this.partserch()
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }
        },
        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    deleteAjefShopBankOptinons({ auwId: row.auwId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = data;
            })
        },
        SureBtn() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        const newForm = JSON.parse(JSON.stringify(this.form))
                        if (newForm.acrAmount == 0) {
                            newForm.acrAmount = newForm.acrAmount2
                        }
                        addAjefShopBankOptinons(newForm).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        updateAjefShopBankOptinons(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen() {
            this.dialog = true;

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.$refs['formRef'].resetFields();
        },

        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.auwId = row.auwId
                    console.log(jsonObj);
                    updateAjefShopBankOptinons(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys(key) {

            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys, key) {

            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item[key]), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {

            const rowKey = row[key];

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getAjefUserWxList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            getAjefUserWxList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });
        },
        getList() {
            getAjefUserWxList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>